// extracted by mini-css-extract-plugin
export var background = "CallToAction-module--background--8073b";